export const searchListe = (kondition, search, changed) => {
  if (changed && !kondition.changed) return false;
  if (typeof search !== "string" || search.length < 3) return true;
  search = search.toLowerCase().trim().replace(/[><"'.?*]/g, "");
  let regexBez = new RegExp(search);
  let regexKz = new RegExp("^" + Number(search));
  return !!(
    String(kondition.bezeichnung).toLowerCase().match(regexBez) ||
    String(kondition.kennziffer).match(regexKz)
  );
};
